import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FactureAchatList from '../components/achat/facture/FactureAchatList';
import SingleFactureAchat from '../components/achat/facture/SingleFactureAchat';
import UnsavedChangesGuard from '../utils/UnsavedChangesGuard';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import './styles/devis-animations.css';

const FactureAchatPage = () => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedId, setSelectedId] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const user = useSelector(state => state.user);
  const userPermissions = {
    isManager: user?.IsManager,
  };

  const handleChangesDetected = () => {
    setHasUnsavedChanges(true);
  };

  const handleChangesSaved = () => {
    setHasUnsavedChanges(false);
  };

  const handleViewChange = useCallback((newView) => {
    if (hasUnsavedChanges) {
      Modal.confirm({
        title: 'Modif. non enregistrées',
        content: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter sans sauvegarder ?',
        okText: 'Quitter',
        cancelText: 'Rester',
        onOk: () => {
          setCurrentView(newView);
          setHasUnsavedChanges(false);
        },
      });
    } else {
      setCurrentView(newView);
    }
  }, [hasUnsavedChanges]);

  const handleSelectFacture = (id) => {
    setSelectedId(id);
    handleViewChange('viewFacture');
  };

  const handleConfirmNavigation = useCallback(() => {
    setHasUnsavedChanges(false);
  }, []);

  // Animation variants
  const pageVariants = {
    initial: {
      opacity: 0,
      scale: 0.97,
    },
    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.15,
        ease: [0.25, 0.1, 0.25, 1.0],
      }
    },
    exit: {
      opacity: 0,
      scale: 0.97,
      transition: {
        duration: 0.12,
        ease: [0.25, 0.1, 0.25, 1.0],
      }
    }
  };

  return (
    <UnsavedChangesGuard
      hasUnsavedChanges={hasUnsavedChanges}
      onConfirmNavigation={handleConfirmNavigation}
    >
      <div className="devis-management-container">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentView}
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageVariants}
            className="view-container"
            style={{
              width: '100%',
              height: '100%'
            }}
          >
            {currentView === 'list' && (
              <FactureAchatList onSelect={handleSelectFacture} />
            )}
            {currentView === 'viewFacture' && selectedId && (
              <SingleFactureAchat
                id={selectedId}
                onStatusChange={() => handleViewChange('list')}
                onClose={() => handleViewChange('list')}
                userPermissions={userPermissions}
                onChangesSaved={handleChangesSaved}
                onChangesDetected={handleChangesDetected}
              />
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </UnsavedChangesGuard>
  );
};

export default FactureAchatPage;
